import { render, staticRenderFns } from "./NonDelivery.vue?vue&type=template&id=61313540&"
import script from "./NonDelivery.vue?vue&type=script&lang=js&"
export * from "./NonDelivery.vue?vue&type=script&lang=js&"
import style0 from "./NonDelivery.vue?vue&type=style&index=0&id=61313540&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports